/**
 * JALRAKSHAK Founders & Digital Visiting Card Details
 * Strictly conforms to the finalized physical visiting card identity.
 */

export const FOUNDERS_DATA = [
  {
    id: 'chetan',
    name: 'Chetan Punj',
    designation: 'Founder',
    organization: 'JALRAKSHAK',
    phone: '8409771216',
    formattedPhone: '+91 84097 71216',
    email: 'chetanpunj481@gmail.com',
    website: 'jalrakshak.in',
    websiteUrl: 'https://jalrakshak.in',
    linkedin: '/in/chetan-punj',
    linkedinUrl: 'https://www.linkedin.com/in/chetan-punj',
    github: 'Chetan2835',
    githubUrl: 'https://github.com/Chetan2835',
    motto: '"Small step for water today, Big change for tomorrow."'
  },
  {
    id: 'anmol',
    name: 'Anmol Agarwal',
    designation: 'Founder',
    organization: 'JALRAKSHAK',
    phone: '6367445454',
    formattedPhone: '+91 63674 45454',
    email: 'reachoutanmolag@gmail.com',
    website: 'jalrakshak.in',
    websiteUrl: 'https://jalrakshak.in',
    linkedin: '/in/anmol',
    linkedinUrl: 'https://www.linkedin.com/in/anmol',
    github: '',
    githubUrl: '',
    motto: '"Empowering autonomous clean water sustainability for future generations."'
  }
];

export const FOUNDER_DATA = FOUNDERS_DATA[0];

/**
 * Generate standard vCard 3.0 string for 1-click contact saving (supports both founders)
 */
export function generateVCardString(founderId = 'all') {
  if (founderId === 'anmol') {
    return [
      'BEGIN:VCARD',
      'VERSION:3.0',
      'FN:Anmol Agarwal',
      'N:Agarwal;Anmol;;;',
      'ORG:JALRAKSHAK',
      'TITLE:Founder',
      'TEL;TYPE=CELL,VOICE:+916367445454',
      'EMAIL;TYPE=INTERNET,WORK:reachoutanmolag@gmail.com',
      'URL:https://jalrakshak.in',
      'X-SOCIALPROFILE;type=linkedin:https://www.linkedin.com/in/anmol',
      'NOTE:JALRAKSHAK - AI + IoT Autonomous System for Water Cleaning & Quality Monitoring',
      'END:VCARD'
    ].join('\r\n');
  }

  // Combined or Chetan
  return [
    'BEGIN:VCARD',
    'VERSION:3.0',
    'FN:Chetan Punj',
    'N:Punj;Chetan;;;',
    'ORG:JALRAKSHAK',
    'TITLE:Founder',
    'TEL;TYPE=CELL,VOICE:+918409771216',
    'EMAIL;TYPE=INTERNET,WORK:chetanpunj481@gmail.com',
    'URL:https://jalrakshak.in',
    'X-SOCIALPROFILE;type=linkedin:https://www.linkedin.com/in/chetan-punj',
    'X-SOCIALPROFILE;type=github:https://github.com/Chetan2835',
    'NOTE:JALRAKSHAK - AI + IoT Autonomous System for Water Cleaning & Quality Monitoring',
    'END:VCARD',
    '',
    'BEGIN:VCARD',
    'VERSION:3.0',
    'FN:Anmol Agarwal',
    'N:Agarwal;Anmol;;;',
    'ORG:JALRAKSHAK',
    'TITLE:Founder',
    'TEL;TYPE=CELL,VOICE:+916367445454',
    'EMAIL;TYPE=INTERNET,WORK:reachoutanmolag@gmail.com',
    'URL:https://jalrakshak.in',
    'X-SOCIALPROFILE;type=linkedin:https://www.linkedin.com/in/anmol',
    'NOTE:JALRAKSHAK - AI + IoT Autonomous System for Water Cleaning & Quality Monitoring',
    'END:VCARD'
  ].join('\r\n');
}
